export default __webpack_public_path__ + "../images/partners-logo-7.png";